<template>
  <canvas ref="canvas" :width="width" :height="height" />
</template>

<script>
// Reemplazo de 'hchs-vue-charts' (abandonado, "Base on Vue2", sin build
// para Vue 3 bajo ningún nombre). Solo hay un consumidor en toda la app
// (DashboardPanel.vue, <chartjs-line> y <chartjs-doughnut>), así que en
// vez de instalar una librería nueva se portó el core real de la
// original (src/vue-chartjs-lib.js + chartjs-line.vue del repo
// GimmyHchs/vue-charts) recortado a lo que ese único consumidor usa.
//
// La original no es reactiva por defecto (su prop `bind` es false salvo
// que se pida explícito, y acá nunca se pide) — el gráfico se dibuja
// una sola vez en mounted(). DashboardPanel.vue ya depende de ese
// comportamiento: fuerza el refresh con `:key="dataVersion"` en vez de
// reactividad interna, así que replicar el mount-once es necesario para
// no cambiar el comportamiento, no una simplificación de mi parte.
//
// `option` siempre viene provisto por el único consumidor real, así que
// a diferencia de la original no hace falta portar su lógica de
// options-por-default cuando no hay override.
export default {
  name: 'ChartjsLine',
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    datalabel: { type: String, default: 'dataset' },
    width: { type: Number, default: null },
    height: { type: Number, default: null },
    bordercolor: { default: 'rgba(75,192,192,1)' },
    backgroundcolor: { default: 'rgba(75,192,192,0.4)' },
    linetension: { type: Number, default: 0.2 },
    fill: { type: Boolean, default: false },
    pointbordercolor: { default: 'rgba(75,192,192,1)' },
    pointbackgroundcolor: { default: '#fff' },
    pointhoverbackgroundcolor: { default: 'rgba(75,192,192,1)' },
    pointhoverbordercolor: { default: 'rgba(220,220,220,1)' },
    pointborderwidth: { type: Number, default: 1 },
    pointhoverborderwidth: { type: Number, default: 2 },
    option: { type: Object, default: null },
  },
  data() {
    return { chart: null };
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [
            {
              type: 'line',
              label: this.datalabel,
              fill: this.fill,
              lineTension: this.linetension,
              backgroundColor: this.backgroundcolor,
              borderColor: this.bordercolor,
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: this.pointbordercolor,
              pointBackgroundColor: this.pointbackgroundcolor,
              pointBorderWidth: this.pointborderwidth,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: this.pointhoverbackgroundcolor,
              pointHoverBorderColor: this.pointhoverbordercolor,
              pointHoverBorderWidth: this.pointhoverborderwidth,
              pointRadius: 1,
              pointHitRadius: 10,
              data: this.data,
              spanGaps: false,
            },
          ],
        },
        options: this.option || {},
      });
    },
  },
};
</script>
